/* @ngInject */
const data = () => {
  const self = {}

  self.myTrains = []

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/data.service.js